import { MODEL_NAMES } from '../constants/index';
import Model, { attr, hasMany } from '@ember-data/model';

export const ROLES = {
  forClient: 'primary clinician',
  forClientContact: 'primary clinician for contact',
  forCouple: 'couple',
};

export default class MessagingContactModel extends Model {
  @hasMany(MODEL_NAMES.CONTACT, { async: false, inverse: null }) couple;

  @attr('boolean', { defaultValue: false }) isRecent;

  @attr('string') externalId;
  @attr('string') externalScope;
  @attr('string') name;
  @attr('string') organizationId;
  @attr('string') parentExternalId;
  @attr('string') role;

  get members() {
    return this.couple?.length ? this.couple : [this];
  }
}
